(function () {
  const searchUrl = window.theme?.routes?.search_url;
  if (!searchUrl) return;

  const autoColourParam = 'auto_colour';

  const recognisedColours = new Map([
    ['black', 'gid://shopify/FilterSettingGroup/219840885'],
    ['blue', 'gid://shopify/FilterSettingGroup/219906421'],
    ['gold', 'gid://shopify/FilterSettingGroup/219808117'],
    ['green', 'gid://shopify/FilterSettingGroup/219939189'],
    ['nude', 'gid://shopify/FilterSettingGroup/220135797'],
    ['orange', 'gid://shopify/FilterSettingGroup/220037493'],
    ['pink', 'gid://shopify/FilterSettingGroup/219971957'],
    ['purple', 'gid://shopify/FilterSettingGroup/220004725'],
    ['red', 'gid://shopify/FilterSettingGroup/219775349'],
    ['silver', 'gid://shopify/FilterSettingGroup/220070261'],
    ['white', 'gid://shopify/FilterSettingGroup/219873653'],
    ['yellow', 'gid://shopify/FilterSettingGroup/220103029'],
  ]);

  function getRecognisedColour(query) {
    const value = String(query || '').trim().toLowerCase();
    if (!value || /[":]/.test(value) || /\b(?:and|or|not)\b/.test(value)) return '';

    const matches = new Set();
    value
      .split(/[^a-z0-9]+/)
      .filter(Boolean)
      .forEach((token) => {
        const colour = recognisedColours.get(token);
        if (colour) matches.add(colour);
      });

    return matches.size === 1 ? Array.from(matches)[0] : '';
  }

  function isSearchUrl(url) {
    return url.origin === window.location.origin && url.pathname === searchUrl;
  }

  function addColourToUrl(url, query) {
    if (
      !isSearchUrl(url) ||
      url.searchParams.get(autoColourParam) === 'off' ||
      url.searchParams.has('filter.v.option.colour')
    ) return false;

    const colour = getRecognisedColour(query);
    if (!colour) return false;

    url.searchParams.set('filter.v.option.colour', colour);
    return true;
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = new URL(form.action || window.location.href, window.location.origin);
      if (!isSearchUrl(action)) return;

      const queryInput = form.elements.namedItem('q');
      const colour = getRecognisedColour(queryInput?.value);
      let colourInput = form.querySelector('[data-recognised-colour-filter]');

      if (!colour) {
        colourInput?.remove();
        return;
      }

      if (!colourInput) {
        colourInput = document.createElement('input');
        colourInput.type = 'hidden';
        colourInput.name = 'filter.v.option.colour';
        colourInput.setAttribute('data-recognised-colour-filter', '');
        form.appendChild(colourInput);
      }

      colourInput.value = colour;
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[href]');
      if (!link) return;

      const url = new URL(link.href, window.location.origin);
      if (link.closest('[data-filter-update-url]')) {
        const query = url.searchParams.get('q');
        if (getRecognisedColour(query) && !url.searchParams.has('filter.v.option.colour')) {
          url.searchParams.set(autoColourParam, 'off');
          link.href = url.toString();
        }
        return;
      }

      if (addColourToUrl(url, url.searchParams.get('q'))) {
        link.href = url.toString();
      }
    },
    true
  );

  const currentUrl = new URL(window.location.href);
  if (addColourToUrl(currentUrl, currentUrl.searchParams.get('q'))) {
    window.location.replace(currentUrl.toString());
  }
})();
